import http from "../../../http-common";
import getErrorMessage from "../../../util";

const post_data = (data) => {
  return http.post('/v1/save_blob_data/', data);
};

export const updload_and_share_data = async (data, view) => {
  try {
    const frontendLink = process.env.REACT_APP_FRONTEND_URL;
    const uploader_response = await post_data(data);
    const response_data = uploader_response.data;
    const { object_key } = response_data;
    const shareable_link = `${frontendLink}/chart/${view}/${object_key}`;
    try {
      return { shareable_link, error: false };
      // if (state === "granted") {
      //   navigator.clipboard.writeText(
      //     shareable_link,
      //   );
      //   return { shareable_link, error: false };
      // }
      // else {
      //   return { error: getErrorMessage(new Error('Permission denied to access clipboard.')), shareable_link: null };
      // }
    } catch (error) {
      return { error: getErrorMessage(error), shareable_link: null };
    }
  } catch (error) {
    return { error: getErrorMessage(error), shareable_link: null };
  }
};